// extracted by mini-css-extract-plugin
export default {"ZoomBg":"Drag_ZoomBg__5njL8","ZoomSlider":"Drag_ZoomSlider__s4gMl"};